<template>
  <div class="panel-filter-container">
    <h3 class="panel-filter-container__label">
      <slot />
    </h3>

    <div class="panel-filter-container__control">
      <slot name="filter" />
    </div>
  </div>
</template>
